import lightBaseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import getMuiTheme from 'material-ui/styles/getMuiTheme';

export default getMuiTheme(lightBaseTheme, {
  palette: {
    primary1Color: '#716aff',
    accent1Color: '#00a2d4',
  },
});



// WEBPACK FOOTER //
// ./src/theme.js